import { CheckBadgeIcon, DocumentArrowUpIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/components/common/tooltip/Tooltip";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Actions as PAYROLL_ACTIONS } from "@/redux/actions/payrollActions";

const PayrollInProgress = ({ profile, payPeriod, updatePayPeriodStatus }) => {
	return (
		<>
			<div
				className="block text-center bg-white"
				style={{ paddingTop: 80 }}
			>
				<div className="main">
					<h1 className="font-w700 text-center">{`Hey ${profile?.givenName || "User"}!`}</h1>
					<div
						className="item item-circle bg-primary"
						style={{ position: "relative", height: "12rem", width: "12rem", marginBottom: 10 }}
					>
						<DocumentArrowUpIcon
							style={{
								postion: "absolute",
								height: "10rem",
								color: "white",
								right: "1rem",
								top: "1rem",
								marginTop: "1rem",
							}}
						/>
						<CheckBadgeIcon
							style={{
								position: "absolute",
								height: "5rem",
								color: "#ea611c",
								right: "0rem",
								top: "6rem",
								background: "white",
								borderRadius: "5rem",
								padding: "0.5rem",
								marginTop: "1rem",
							}}
						/>
					</div>
					<h3 className="text-center">
						You're almost there! Your data has been submitted successfully, your advisor will notify you
						once it is processed!
					</h3>
					<div style={{ marginTop: 30 }}>
						<Link
							type="button"
							className="btn btn-default"
							to="/people"
						>
							Return to home
						</Link>
						<Tooltip
							as="button"
							content={
								<>
									If there is anything you need to add or change, you
									<br />
									may re-open this to resubmit with your new data
								</>
							}
							className="btn btn-warning"
							type="button"
							style={{ marginLeft: 10 }}
							onClick={() => updatePayPeriodStatus(payPeriod?.id, "Open")}
						>
							Something's Missing...
						</Tooltip>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		profile: state?.my?.profile,
		payPeriod: state.payroll?.payPeriodDetails,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updatePayPeriodStatus: (id, status) => dispatch(PAYROLL_ACTIONS.updatePayPeriodStatus(id, status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollInProgress);
